export const environment = {
  production: true,
  djangoApiUrl: 'https://api.genwattinvestmentgroup.com/api'
};
